import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import ConsolidatedDaywiseReportView from './ConsolidatedDaywiseReportView'

const ConsolidatedDaywiseReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Consolidated Daywise Report" mainTitle="Consolidated Daywise Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ConsolidatedDaywiseReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default ConsolidatedDaywiseReport